import { defineComponent as _defineComponent } from 'vue'
import { useVuetify } from "@/plugins/vuetify";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppThemeToggle',
  setup(__props) {

const vuetify = useVuetify();

const toggleTheme = () => {
  localStorage.setItem("elinor/theme", vuetify.theme.dark ? "dark" : "light");
};

return { __sfc: true,vuetify, toggleTheme }
}

})